import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { FaRegEye } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import Select, { components } from 'react-select';
import axios from "axios";


function AllVerifiedCall() {
      const [toast, setToast] = useState({
            show: false,
            message: '',
            bg: 'success'
        });
    
        const showToast = (message, bg = 'success') => {
            setToast({ show: true, message, bg });
        };
          const [detail, setDetail] = useState([]);
          
              const fetchCallDetail = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-call-detail");
              const filteredData = res.data.filter(item => item.data_type === 'verified');
            setDetail(filteredData);
        } catch (error) {
            console.log(error)
        }
    }

  useEffect(() => {
        fetchCallDetail();
   

    }, [])

  return (
       <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <h3 className='my-3 fw-bold fs-5 golos'>Verified Call List</h3>

                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className="table table-bordered table-striped text-center table-sm align-middle">
                        <thead className="table-info">
                            <tr>
                                <th>SN No</th>
                                <th> Name</th>
                                <th>Phone</th>
                                <th>Address</th>
                                <th>Status </th>
                 

                            </tr>
                        </thead>
                        <tbody>
                            {detail.map((p, i) => (
                                <tr key={p.id}>
                                    <td>{i + 1}</td>
                                    <td>{p.name} </td>
                                    <td>{p.number} </td>
                                    <td>{p.address} </td>
                                    <td> {p.data_type} </td>
                                
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
         

            </div>
        </div>
  )
}

export default AllVerifiedCall